module.exports = __webpack_public_path__ + "img/3.913d2b94.png";